export default __webpack_public_path__ + "src/images/controller_loading-9b165c.png";